/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 *//* ==========================================================================
   FRAVE ENHANCEMENTS — appended below Focal's documentation stub.
   01 <frave-scent-filter>  tabs + note chips filtering with FLIP reflow
   02 <frave-kit-builder>   diffuser + scent two-step picker, combined cart add
   03 scent-notes hover overlay (built from the section's data attributes)
   04 fade page transitions
   Styles live in assets/frave-enhance.css. Everything fails open: without
   this file the filter section still shows all products, overlays simply
   don't appear, and navigation is normal.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  /* ---- Shared money formatter --------------------------------------------
     Implements Shopify's {{amount}} / {{amount_no_decimals}} /
     {{amount_with_comma_separator}} tokens against shop.money_format, since
     that's the only shop-currency source available client-side without an
     extra network call. */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var defaultFormat = '${{amount}}';
    format = format || defaultFormat;

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }

    switch (format.match(placeholder)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---- 02 · Kit builder --------------------------------------------------- */

  var FraveKitBuilder = class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-role="group"]'));
      this.selections = {}; // group name -> { variantId, price, title }
      this.addButton = this.querySelector('[data-role="add-to-cart"]');
      this.errorEl = this.querySelector('[data-role="error"]');
      this.totalEl = this.querySelector('[data-role="summary-total"]');

      // Step 2 reuses the homepage Frave Scent Filter's tabs+chips picker
      // (frave-scent-filter.liquid), just filtering this tile grid instead
      // of a product-item grid. Only wired up if the section actually has
      // tab blocks / note metafields — fails open to a plain grid otherwise.
      this.scentGroup = this.querySelector('[data-group="scent"]');
      this.scentItems = this.scentGroup ? Array.prototype.slice.call(this.scentGroup.querySelectorAll('[data-role="tile"]')) : [];
      this.scentTabs = Array.prototype.slice.call(this.querySelectorAll('.frave-filter__tab'));
      this.chipsEl = this.querySelector('[data-role="chips"]');
      this.scentEmpty = this.querySelector('[data-role="empty"]');
      this.activeNote = 'all';
      var activeTabEl = this.scentTabs.filter(function (t) { return t.classList.contains('is-active'); })[0];
      this.activeTab = activeTabEl ? activeTabEl.dataset.tab : 'all';

      this._buildChips();
      this._buildScentOverlays();
      if (this.activeTab !== 'all') this._applyFilter();

      var self = this;
      this.addEventListener('click', function (e) {
        var tile = e.target.closest('[data-role="tile"]');
        if (tile && !tile.disabled) { self._selectTile(tile); return; }
        var tab = e.target.closest('.frave-filter__tab');
        if (tab) { self._pickFilter('activeTab', tab.dataset.tab, self.scentTabs, tab); return; }
        var chip = e.target.closest('.frave-filter__chip');
        if (chip) { self._pickFilter('activeNote', chip.dataset.note, self.chips, chip); return; }
        var addBtn = e.target.closest('[data-role="add-to-cart"]');
        if (addBtn && !addBtn.disabled) { self._addToCart(); }
      });
    }

    _buildChips() {
      if (!this.chipsEl) return;
      var seen = {}, self = this;
      var frag = document.createDocumentFragment();
      frag.appendChild(this._chip('all', 'All', true));
      this.scentItems.forEach(function (it) {
        var n = it.dataset.note;
        if (!n || seen[n]) return;
        seen[n] = true;
        frag.appendChild(self._chip(n, it.dataset.noteLabel || titleCase(n), false));
      });
      if (Object.keys(seen).length > 1) this.chipsEl.appendChild(frag);
      this.chips = Array.prototype.slice.call(this.chipsEl.children);
    }

    _chip(value, label, active) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'frave-filter__chip' + (active ? ' is-active' : '');
      b.dataset.note = value;
      b.textContent = label;
      return b;
    }

    /* Same hover-overlay behavior as the homepage Frave Scent Filter's
       _buildOverlays() — reads each scent tile's data-notes-full and drops a
       .frave-notes-overlay into its .frave-kit__tile-image (that class
       already carries position:relative + overflow:hidden, and
       .frave-notes-overlay's own rules are unscoped, so it needs nothing
       else to anchor correctly). Only Step 2 gets this — diffuser tiles in
       Step 1 have no notes to show. */
    _buildScentOverlays() {
      this.scentItems.forEach(function (tile) {
        var notes = tile.dataset.notesFull;
        if (!notes) return;
        var wrapper = tile.querySelector('.frave-kit__tile-image');
        if (!wrapper || wrapper.querySelector('.frave-notes-overlay')) return;
        var el = document.createElement('div');
        el.className = 'frave-notes-overlay';
        var head = document.createElement('strong');
        head.textContent = 'Notes';
        el.appendChild(head);
        el.appendChild(document.createTextNode(notes));
        wrapper.appendChild(el);
      });
    }

    _pickFilter(prop, value, group, btn) {
      this[prop] = value;
      (group || []).forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this._applyFilter();
    }

    _matchesFilter(tile) {
      var tabOk = this.activeTab === 'all' ||
        (' ' + (tile.dataset.collections || '') + ' ').indexOf(' ' + this.activeTab + ' ') !== -1;
      var noteOk = this.activeNote === 'all' || tile.dataset.note === this.activeNote;
      return tabOk && noteOk;
    }

    _applyFilter() {
      var self = this;
      var shown = 0;
      this.scentItems.forEach(function (tile) {
        var ok = self._matchesFilter(tile);
        tile.hidden = !ok;
        if (ok) shown++;
      });
      if (this.scentEmpty) this.scentEmpty.hidden = shown !== 0;
    }

    _selectTile(tile) {
      var group = tile.closest('[data-role="group"]');
      var groupName = group.dataset.group;

      Array.prototype.slice.call(group.querySelectorAll('[data-role="tile"]')).forEach(function (t) {
        t.classList.toggle('is-active', t === tile);
      });

      this.selections[groupName] = {
        variantId: tile.dataset.variantId,
        price: parseInt(tile.dataset.price, 10),
        title: tile.dataset.title
      };

      var valueEl = this.querySelector('[data-role="summary-' + groupName + '-value"]');
      if (valueEl) { valueEl.textContent = tile.dataset.title; valueEl.classList.remove('is-empty'); }

      var previewEl = this.querySelector('[data-role="preview-' + groupName + '"]');
      if (previewEl) {
        var img = tile.querySelector('img');
        previewEl.classList.remove('is-empty');
        previewEl.innerHTML = img ? '<img src="' + img.src + '" alt="' + tile.dataset.title + '">' : '';
      }

      this._updateSummary();
    }

    _updateSummary() {
      var diffuser = this.selections.diffuser;
      var scent = this.selections.scent;
      var total = (diffuser ? diffuser.price : 0) + (scent ? scent.price : 0);
      if (this.totalEl) this.totalEl.textContent = formatMoney(total, this.moneyFormat);
      if (this.addButton) this.addButton.disabled = !(diffuser && scent);
    }

    _setError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || '';
      this.errorEl.hidden = !message;
    }

    async _addToCart() {
      var diffuser = this.selections.diffuser;
      var scent = this.selections.scent;
      if (!diffuser || !scent) return;

      this._setError('');
      this.addButton.disabled = true;
      this.addButton.setAttribute('aria-busy', 'true');

      try {
        var response = await fetch(window.themeVariables.routes.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: [
              { id: diffuser.variantId, quantity: 1 },
              { id: scent.variantId, quantity: 1 }
            ],
            sections: ['mini-cart']
          })
        });
        var responseJson = await response.json();

        if (!response.ok) {
          this._setError(responseJson.description || responseJson.message || 'Something went wrong adding this kit to your cart.');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          return;
        }

        if (window.themeVariables.settings.cartType === 'drawer') {
          var cartResponse = await fetch(window.themeVariables.routes.cartUrl + '.js');
          var cartContent = await cartResponse.json();
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartContent } }));
          cartContent.sections = responseJson.sections;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: cartContent, openMiniCart: true }
          }));
          this.classList.add('is-added');
        } else {
          window.location.href = Shopify.routes.root + 'cart';
        }
      } catch (err) {
        this._setError('Something went wrong adding this kit to your cart.');
      } finally {
        this.addButton.removeAttribute('aria-busy');
        this._updateSummary();
      }
    }
  };

  if (!customElements.get('frave-kit-builder')) {
    customElements.define('frave-kit-builder', FraveKitBuilder);
  }

  /* ---- Color picker (reed / crystal diffusers) --------------------------
     Different cart mechanics from the kit builder above: there's no second
     product to combine, so Step 1 just decides which color's Step 2 variant
     group is visible, and only the Step 2 variant (one product, one variant)
     ever gets added to cart. */

  var FraveColorPicker = class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.colorGroup = this.querySelector('[data-group="color"]');
      this.colorTiles = this.colorGroup ? Array.prototype.slice.call(this.colorGroup.querySelectorAll('[data-role="tile"]')) : [];
      this.colorGroupEls = Array.prototype.slice.call(this.querySelectorAll('[data-role="color-group"]'));
      this.selections = {}; // color: { title }, scent: { variantId, price, title }
      this.addButton = this.querySelector('[data-role="add-to-cart"]');
      this.errorEl = this.querySelector('[data-role="error"]');
      this.totalEl = this.querySelector('[data-role="summary-total"]');

      var self = this;
      this.addEventListener('click', function (e) {
        var colorTile = e.target.closest('[data-group="color"] [data-role="tile"]');
        if (colorTile && !colorTile.disabled) { self._selectColor(colorTile); return; }
        var scentTile = e.target.closest('[data-role="color-group"]:not([hidden]) [data-role="tile"]');
        if (scentTile && !scentTile.disabled) { self._selectScent(scentTile); return; }
        var addBtn = e.target.closest('[data-role="add-to-cart"]');
        if (addBtn && !addBtn.disabled) { self._addToCart(); }
      });
    }

    _selectColor(tile) {
      var handle = tile.dataset.color;

      this.colorTiles.forEach(function (t) { t.classList.toggle('is-active', t === tile); });
      this.colorGroupEls.forEach(function (g) { g.hidden = g.dataset.color !== handle; });

      this.selections.color = { title: tile.dataset.title };
      // A different color means a different variant list — last color's
      // scent pick no longer applies, so clear it rather than leave a stale
      // (and possibly now-invisible) selection sitting in the summary.
      this.selections.scent = null;

      var colorValueEl = this.querySelector('[data-role="summary-color-value"]');
      if (colorValueEl) { colorValueEl.textContent = tile.dataset.title; colorValueEl.classList.remove('is-empty'); }
      var scentValueEl = this.querySelector('[data-role="summary-scent-value"]');
      if (scentValueEl) { scentValueEl.textContent = 'Not selected'; scentValueEl.classList.add('is-empty'); }

      var colorPreview = this.querySelector('[data-role="preview-color"]');
      if (colorPreview) {
        var img = tile.querySelector('img');
        colorPreview.classList.remove('is-empty');
        colorPreview.innerHTML = img ? '<img src="' + img.src + '" alt="' + tile.dataset.title + '">' : '';
      }
      var scentPreview = this.querySelector('[data-role="preview-scent"]');
      if (scentPreview) { scentPreview.classList.add('is-empty'); scentPreview.innerHTML = 'Scent'; }

      this._updateSummary();
    }

    _selectScent(tile) {
      var group = tile.closest('[data-role="color-group"]');
      Array.prototype.slice.call(group.querySelectorAll('[data-role="tile"]')).forEach(function (t) {
        t.classList.toggle('is-active', t === tile);
      });

      this.selections.scent = {
        variantId: tile.dataset.variantId,
        price: parseInt(tile.dataset.price, 10),
        title: tile.dataset.title
      };

      var valueEl = this.querySelector('[data-role="summary-scent-value"]');
      if (valueEl) { valueEl.textContent = tile.dataset.title; valueEl.classList.remove('is-empty'); }

      var previewEl = this.querySelector('[data-role="preview-scent"]');
      if (previewEl) {
        var img = tile.querySelector('img');
        previewEl.classList.remove('is-empty');
        previewEl.innerHTML = img ? '<img src="' + img.src + '" alt="' + tile.dataset.title + '">' : '';
      }

      this._updateSummary();
    }

    _updateSummary() {
      var scent = this.selections.scent;
      var total = scent ? scent.price : 0;
      if (this.totalEl) this.totalEl.textContent = formatMoney(total, this.moneyFormat);
      if (this.addButton) this.addButton.disabled = !(this.selections.color && scent);
    }

    _setError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || '';
      this.errorEl.hidden = !message;
    }

    async _addToCart() {
      var scent = this.selections.scent;
      if (!scent) return;

      this._setError('');
      this.addButton.disabled = true;
      this.addButton.setAttribute('aria-busy', 'true');

      try {
        var response = await fetch(window.themeVariables.routes.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: [{ id: scent.variantId, quantity: 1 }],
            sections: ['mini-cart']
          })
        });
        var responseJson = await response.json();

        if (!response.ok) {
          this._setError(responseJson.description || responseJson.message || 'Something went wrong adding this to your cart.');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          return;
        }

        if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
          window.location.href = Shopify.routes.root + 'cart';
          return;
        }

        var cartResponse = await fetch(window.themeVariables.routes.cartUrl + '.js');
        var cartContent = await cartResponse.json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartContent } }));
        cartContent.sections = responseJson.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cartContent, openMiniCart: window.themeVariables.settings.cartType === 'drawer' }
        }));
      } catch (err) {
        this._setError('Something went wrong adding this to your cart.');
      } finally {
        this.addButton.removeAttribute('aria-busy');
        this._updateSummary();
      }
    }
  };

  if (!customElements.get('frave-color-picker')) {
    customElements.define('frave-color-picker', FraveColorPicker);
  }

  /* ---- Kit Builder: swap Quick Buy for a plain link on target product(s) --
     Quick Buy (the popover/drawer opened from a product card on collection/
     search/recommendation grids) fetches that product's own page and reads a
     <template id="quick-buy-content"> out of it (product-quick-buy.liquid,
     rendered unconditionally inside main-product.liquid) — that markup lives
     outside .product, so the Kit Builder section's page-hide <style> never
     reaches it, and it would show the plain Color/Scent dropdown form instead
     of Kit Builder. Rather than reimplementing Kit Builder inside the small
     popover, the trigger button on any product card pointing at a Kit
     Builder target gets converted into a plain link to that product's real
     page (same look/position, just navigates instead of opening a popover).
     This list can't be read off the section's own settings the way the
     .product hide-style is, because the Kit Builder section only renders on
     the target product's own page — never on a collection page showing its
     card — so there's nothing on the collection page to read it from. Update
     this by hand whenever a product's buy box gets replaced by Kit Builder /
     Color Picker. */
  var FRAVE_KIT_BUILDER_TARGETS = ['lumix-diffuser-discovery-set', 'air-lux-diffuser-discovery-set'];

  (function () {
    function convertQuickBuy(root) {
      var targets = FRAVE_KIT_BUILDER_TARGETS;
      if (!targets || !targets.length) return;
      var items = (root || document).querySelectorAll('.product-item');
      items.forEach(function (item) {
        var link = item.querySelector('a[href*="/products/"]');
        if (!link) return;
        var href = link.getAttribute('href');
        var isTarget = targets.some(function (handle) {
          return href.indexOf('/products/' + handle) !== -1;
        });
        if (!isTarget) return;

        item.querySelectorAll('quick-buy-popover, quick-buy-drawer').forEach(function (el) {
          el.remove();
        });

        item.querySelectorAll('.product-item__quick-buy-button').forEach(function (btn) {
          if (btn.dataset.fraveKitLink) return; // already converted
          var a = document.createElement('a');
          a.href = href;
          a.className = btn.className;
          a.innerHTML = btn.innerHTML;
          a.dataset.fraveKitLink = 'true';
          var label = btn.getAttribute('title') || btn.getAttribute('aria-label');
          if (label) a.setAttribute('title', label);
          btn.replaceWith(a);
        });
      });
    }

    convertQuickBuy();
    new MutationObserver(function () { convertQuickBuy(); }).observe(document.body || document.documentElement, {
      childList: true, subtree: true
    });
  })();

  /* ---- 01 · Scent filter ------------------------------------------------ */

  function titleCase(handle) {
    return (handle || '').replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  var FraveScentFilter = class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.grid = this.querySelector('[data-role="grid"]');
      this.empty = this.querySelector('[data-role="empty"]');
      this.chipsEl = this.querySelector('[data-role="chips"]');
      this.items = Array.prototype.slice.call(this.querySelectorAll('.frave-filter__item'));
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('.frave-filter__tab'));
      this.activeNote = 'all';

      // Default tab is whichever button the template marked is-active (the
      // first configured collection tab, not "all" — see frave-scent-filter
      // .liquid). Read it from the DOM instead of hardcoding, so markup and
      // behavior can't drift apart.
      var activeTabEl = this.tabs.filter(function (t) { return t.classList.contains('is-active'); })[0];
      this.activeTab = activeTabEl ? activeTabEl.dataset.tab : 'all';

      this._buildChips();
      this._buildOverlays();
      if (this.activeTab !== 'all') this._apply(false); // hide non-matching items before first paint's animation would matter

      var self = this;
      this.addEventListener('click', function (e) {
        var tab = e.target.closest('.frave-filter__tab');
        if (tab) { self._pick('activeTab', tab.dataset.tab, self.tabs, tab); return; }
        var chip = e.target.closest('.frave-filter__chip');
        if (chip) { self._pick('activeNote', chip.dataset.note, self.chips, chip); }
      });
    }

    _buildChips() {
      if (!this.chipsEl) return;
      var seen = {}, self = this;
      var frag = document.createDocumentFragment();
      frag.appendChild(this._chip('all', 'All', true));
      this.items.forEach(function (it) {
        var n = it.dataset.note;
        if (!n || seen[n]) return;
        seen[n] = true;
        frag.appendChild(self._chip(n, it.dataset.noteLabel || titleCase(n), false));
      });
      // Only render chips if there are at least 2 real notes to filter by.
      if (Object.keys(seen).length > 1) this.chipsEl.appendChild(frag);
      this.chips = Array.prototype.slice.call(this.chipsEl.children);
    }

    _chip(value, label, active) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'frave-filter__chip' + (active ? ' is-active' : '');
      b.dataset.note = value;
      b.textContent = label;
      return b;
    }

    /* Build the hover overlay inside each Focal product card image. */
    _buildOverlays() {
      this.items.forEach(function (it) {
        var notes = it.dataset.notesFull;
        if (!notes) return;
        var wrapper = it.querySelector('.product-item__image-wrapper');
        if (!wrapper || wrapper.querySelector('.frave-notes-overlay')) return;
        var el = document.createElement('div');
        el.className = 'frave-notes-overlay';
        var head = document.createElement('strong');
        head.textContent = 'Notes';
        el.appendChild(head);
        el.appendChild(document.createTextNode(notes));
        wrapper.appendChild(el);
      });
    }

    _pick(prop, value, group, btn) {
      this[prop] = value;
      (group || []).forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this._apply();
    }

    _matches(it) {
      var tabOk = this.activeTab === 'all' ||
        (' ' + (it.dataset.collections || '') + ' ').indexOf(' ' + this.activeTab + ' ') !== -1;
      var noteOk = this.activeNote === 'all' || it.dataset.note === this.activeNote;
      return tabOk && noteOk;
    }

    _apply() {
      var self = this;
      var animate = !REDUCED;

      var first = animate ? this.items.map(function (it) {
        return it.hidden ? null : it.getBoundingClientRect();
      }) : null;

      var shown = 0;
      this.items.forEach(function (it) {
        var ok = self._matches(it);
        it.hidden = !ok;
        if (ok) shown++;
      });
      if (this.empty) this.empty.hidden = shown !== 0;
      if (!animate) return;

      this.items.forEach(function (it, i) {
        if (it.hidden) return;
        if (!first[i]) {
          // entering card: fade + scale in
          it.animate(
            [{ opacity: 0, transform: 'scale(0.96)' }, { opacity: 1, transform: 'none' }],
            { duration: 450, easing: EASE }
          );
          return;
        }
        var last = it.getBoundingClientRect();
        var dx = first[i].left - last.left;
        var dy = first[i].top - last.top;
        if (!dx && !dy) return;
        it.animate(
          [{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }],
          { duration: 500, easing: EASE }
        );
      });
    }
  };

  if (!customElements.get('frave-scent-filter')) {
    customElements.define('frave-scent-filter', FraveScentFilter);
  }

  /* ---- Complementary products: prev/next carousel nav -------------------
     <product-recommendations> (theme.js) fetches its up-to-10 complementary
     product cards asynchronously and drops them into a horizontally
     scrolling row (frave-enhance.css). All 10 really are there and the row
     really does scroll — confirmed via scrollWidth vs clientWidth — but the
     scrollbar is hidden for a cleaner look, and on desktop (no touch swipe)
     that left nothing telling anyone there was more to see. These buttons
     are the discoverable way to reach the rest; touch devices already have
     swipe, so frave-enhance.css hides the buttons there (hover:none). */
  function buildCarouselNavButton(direction) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'frave-carousel-nav frave-carousel-nav--' + direction;
    b.setAttribute('aria-label', direction === 'prev' ? 'Scroll left' : 'Scroll right');
    b.innerHTML = direction === 'prev'
      ? '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function setupCarouselNav(el) {
    var scroller = el.querySelector('.scroller');
    if (!scroller || scroller.dataset.fraveNavReady) return;
    scroller.dataset.fraveNavReady = 'true';

    var prevBtn = buildCarouselNavButton('prev');
    var nextBtn = buildCarouselNavButton('next');
    el.appendChild(prevBtn);
    el.appendChild(nextBtn);

    function update() {
      var atEnd = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 4;
      prevBtn.hidden = scroller.scrollLeft <= 4;
      nextBtn.hidden = atEnd;
      // The right-edge fade (frave-enhance.css) implies "more to scroll to" —
      // drop it once the true last card is fully in view so it doesn't look
      // like something's still cut off when there's nothing left.
      scroller.classList.toggle('is-at-end', atEnd);
    }
    prevBtn.addEventListener('click', function () {
      scroller.scrollBy({ left: -scroller.clientWidth * 0.9, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      scroller.scrollBy({ left: scroller.clientWidth * 0.9, behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();
  }

  function wireFeaturedProducts(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.product-content__featured-products').forEach(function (el) {
      // <product-recommendations>'s own connectedCallback starts its fetch as
      // soon as the element is parsed, well before this script runs — if
      // that fetch resolves first, content is already in the DOM by the
      // time we get here, and a MutationObserver set up now would watch for
      // a mutation that already happened and never fire. Check synchronously
      // first; only fall back to observing if it genuinely hasn't loaded yet.
      if (el.querySelector('.scroller')) {
        setupCarouselNav(el);
        return;
      }
      var observer = new MutationObserver(function () {
        setupCarouselNav(el);
        if (el.querySelector('.scroller')) observer.disconnect();
      });
      observer.observe(el, { childList: true });
    });
  }

  wireFeaturedProducts(document);

  // Shopify's theme editor (Customize) re-renders a section via AJAX
  // whenever it's selected/edited and swaps in fresh HTML, dispatching
  // shopify:section:load on the section's wrapper — the one-time setup
  // above never sees that replacement content. Re-run it scoped to
  // whatever section just (re)loaded, on both storefront and editor.
  document.addEventListener('shopify:section:load', function (event) {
    wireFeaturedProducts(event.target);
  });

  /* ---- Fragrance variant carousel: draggable scrub bar (no arrows) -------
     The row itself already scrolls natively (touch swipe, trackpad). This
     adds a thin bar below it — .frave-variant-carousel__track/__thumb,
     markup in product-form-option.liquid — as an explicit, always-visible
     mouse-drag handle instead of prev/next buttons, since a plain overflow
     row gives desktop mouse users no visual cue that it's scrollable or how
     far there is left to go.
     History: this was tried, then reverted to arrows after a user report of
     fragrances disappearing/becoming unscrollable, then root-caused (it was
     never this drag logic — it was the scroll-to-selected-fragrance code
     below misusing scrollIntoView) and reinstated. See
     docs/frave-rebuild-changelog.md §6 for the full story. */
  function setupScrollThumb(el) {
    var scroller = el.querySelector('.scroller');
    var track = el.querySelector('.frave-variant-carousel__track');
    var thumb = track && track.querySelector('.frave-variant-carousel__thumb');
    if (!scroller || !track || !thumb || scroller.dataset.fraveThumbReady) return;
    scroller.dataset.fraveThumbReady = 'true';

    function update() {
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var scrollable = maxScroll > 1;
      track.hidden = !scrollable;
      scroller.classList.toggle('is-at-end', !scrollable || scroller.scrollLeft >= maxScroll - 4);
      if (!scrollable) return;
      var trackWidth = track.clientWidth;
      var thumbWidth = Math.max(trackWidth * (scroller.clientWidth / scroller.scrollWidth), 24);
      var progress = scroller.scrollLeft / maxScroll;
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + (progress * (trackWidth - thumbWidth)) + 'px)';
    }

    var dragging = false, dragStartX = 0, dragStartScroll = 0, justDragged = false;

    // Pointer Events (not separate mousedown/touchstart listeners) — mouse
    // and touch input on the same element can both fire for one physical
    // interaction (e.g. under touch-emulated environments like a browser's
    // device-emulation mode), which would start two overlapping drag
    // sessions fighting over the same scroller. Pointer Events unify mouse/
    // touch/pen into a single event stream per interaction, so this can't
    // double-fire.
    function onDrag(e) {
      if (!dragging) return;
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var usableTrack = Math.max(track.clientWidth - thumb.offsetWidth, 1);
      scroller.scrollLeft = dragStartScroll + ((e.clientX - dragStartX) / usableTrack) * maxScroll;
      e.preventDefault();
    }
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      document.removeEventListener('pointermove', onDrag);
      document.removeEventListener('pointerup', endDrag);
      document.removeEventListener('pointercancel', endDrag);
      // Swallow the click that follows pointerup when it lands on the track
      // (not the thumb) so releasing a drag doesn't also trigger jumpTo.
      justDragged = true;
      setTimeout(function () { justDragged = false; }, 0);
    }
    thumb.addEventListener('pointerdown', function (e) {
      dragging = true;
      dragStartX = e.clientX;
      dragStartScroll = scroller.scrollLeft;
      track.classList.add('is-dragging');
      document.addEventListener('pointermove', onDrag);
      document.addEventListener('pointerup', endDrag);
      document.addEventListener('pointercancel', endDrag);
      e.preventDefault();
    });

    track.addEventListener('click', function (e) {
      if (justDragged || e.target === thumb) return;
      var rect = track.getBoundingClientRect();
      var usableTrack = Math.max(track.clientWidth - thumb.offsetWidth, 1);
      var targetProgress = (e.clientX - rect.left - thumb.offsetWidth / 2) / usableTrack;
      targetProgress = Math.min(Math.max(targetProgress, 0), 1);
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      scroller.scrollTo({ left: targetProgress * maxScroll, behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();
  }

  /* Same body-wide MutationObserver idiom as the Kit Builder quick-buy
     conversion above: picking a fragrance fires theme.js's <product-rerender>,
     which replaces the *entire* [data-block-type="variant-picker"] element
     with freshly-rendered server HTML on every selection, so shopify:section:load
     alone isn't enough — this re-runs setup whenever that swap happens too. */
  function wireVariantCarousels(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.frave-variant-carousel').forEach(function (el) {
      setupScrollThumb(el);

      // Scroll the newly-selected fragrance into view — but only once, right
      // as this (freshly server-rendered) scroller first appears, guarded
      // separately from setupCarouselNav's own dataset flag since that
      // function is shared with the complementary-products carousel. This
      // used to run unconditionally on every call here, which meant it fired
      // on *any* unrelated page mutation (not just an actual selection
      // change) and kept snapping the scroll position back to the selected
      // item, fighting anyone who'd manually scrolled away from it.
      var scroller = el.querySelector('.scroller');
      if (!scroller || scroller.dataset.fraveScrolledToSelection) return;
      scroller.dataset.fraveScrolledToSelection = 'true';
      var selected = scroller.querySelector('.variant-swatch__item.is-selected, .variant-swatch__radio:checked + .variant-swatch__item');
      if (selected) {
        // NOT selected.scrollIntoView(). The real root cause of fragrances
        // "disappearing" turned out to be broader than this call: clicking a
        // fragrance label focuses its associated (visually-hidden) radio
        // input, and the browser's native "scroll the focused element into
        // view" behavior walks up and scrolls *every* scrollable ancestor —
        // scrollIntoView triggers the same walk, but so does plain .focus()
        // with zero JS scroll code involved (confirmed live). That's fixed
        // at the CSS layer: .frave-variant-carousel now uses overflow:clip
        // instead of overflow:hidden, which is explicitly non-scrollable, so
        // neither focus nor scrollIntoView can touch its scrollLeft anymore.
        // See frave-enhance.css and docs/frave-rebuild-changelog.md §6.
        // This getBoundingClientRect approach is kept anyway (belt and
        // suspenders) since it only ever touches scroller.scrollLeft.
        var itemRect = selected.getBoundingClientRect();
        var scrollerRect = scroller.getBoundingClientRect();
        scroller.scrollLeft += itemRect.left - scrollerRect.left;
      }
    });
  }

  wireVariantCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    wireVariantCarousels(event.target);
  });
  new MutationObserver(function () {
    wireVariantCarousels(document);
  }).observe(document.body || document.documentElement, {
    childList: true, subtree: true
  });

  /* Moves .frave-scent-info (the "Reed Diffuser" type line) from its
     rendered position — first block in product-form.liquid, which lands it
     after price/description — to directly after the product title, before
     price, matching Diptyque's Name / "Eau de parfum" stacking. Done in JS
     rather than Liquid because title+price live in the shared
     <product-meta> markup (used by every template) while .frave-scent-info
     is rendered separately inside product-form's blocks loop — no
     block-order setting can interleave the two. One-time move per element
     (guarded by the dataset flag): .frave-scent-info is static per-product
     content, not variant-specific, so it's never re-rendered by
     <product-rerender> on a variant switch and doesn't need re-wiring. */
  function wireScentInfoPosition(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.frave-scent-info').forEach(function (info) {
      if (info.dataset.fraveRepositioned) return;
      var title = info.closest('.product__info')?.querySelector('.product-meta__title');
      if (!title) return;
      title.insertAdjacentElement('afterend', info);
      info.dataset.fraveRepositioned = 'true';
    });
  }
  wireScentInfoPosition(document);
  document.addEventListener('shopify:section:load', function (event) {
    wireScentInfoPosition(event.target);
  });

  /* Desktop-only "Read more" toggle for long product descriptions (CSS does
     the 4-line clamp at >=1000px, see frave-enhance.css §09d). Only shows
     the toggle button when the text actually overflows the clamp — short
     descriptions never get one. Re-checked on resize since crossing the
     1000px breakpoint changes whether the clamp (and therefore overflow)
     applies at all. */
  function wireDescriptionReadMore(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-description-wrapper]').forEach(function (wrapper) {
      var content = wrapper.querySelector('[data-description-content]');
      var toggle = wrapper.querySelector('[data-description-toggle]');
      if (!content || !toggle) return;

      if (!wrapper.dataset.fraveReadMoreWired) {
        wrapper.dataset.fraveReadMoreWired = 'true';
        toggle.addEventListener('click', function () {
          var expanded = wrapper.classList.toggle('is-expanded');
          toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
        });
      }

      wrapper.classList.remove('is-expanded');
      toggle.textContent = toggle.dataset.labelMore;
      toggle.hidden = content.scrollHeight <= content.clientHeight + 1;
    });
  }
  wireDescriptionReadMore(document);
  document.addEventListener('shopify:section:load', function (event) {
    wireDescriptionReadMore(event.target);
  });
  var fraveReadMoreResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(fraveReadMoreResizeTimer);
    fraveReadMoreResizeTimer = setTimeout(function () {
      wireDescriptionReadMore(document);
    }, 150);
  });

  /* ---- Main gallery: back arrow only once scrolled past photo one -------
     Diptyque's gallery only shows a forward arrow while on the first photo
     (nothing to go back to yet) — Focal's flickity-controls (theme.js)
     always renders and wires both prev/next buttons with no such state.
     The prev button starts [hidden] in markup (product-media.liquid); this
     reads the real position off <flickity-carousel>'s own flickityInstance
     promise (theme.js) via the flickity:ready/flickity:slide-changed
     events it dispatches on itself, and toggles [hidden] to match. */
  function wireGalleryPrevArrow(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.product__media').forEach(function (mediaEl) {
      var carousel = mediaEl.querySelector('.product__media-list');
      var prevButtons = mediaEl.querySelectorAll('.product__media-nav .product__media-prev-next[data-action="prev"]');
      if (!carousel || !prevButtons.length || carousel.dataset.fravePrevArrowWired) return;
      carousel.dataset.fravePrevArrowWired = 'true';

      function update() {
        carousel.flickityInstance.then(function (instance) {
          var atStart = instance.selectedIndex === 0;
          prevButtons.forEach(function (btn) { btn.hidden = atStart; });
        });
      }
      carousel.addEventListener('flickity:ready', update);
      carousel.addEventListener('flickity:slide-changed', update);
    });
  }
  wireGalleryPrevArrow(document);
  document.addEventListener('shopify:section:load', function (event) {
    wireGalleryPrevArrow(event.target);
  });

  /* ---- Scent photo half-gallery: nav + reset on scent change ------------
     Opt-in products (product-media.liquid, frave_variant_photo_enabled)
     get a hero slide (product photo + current scent photo) followed by
     the other standalone product shots as further peek slides. On desktop
     the hero is a real flex row (its two .pane children are 50/50 within
     it, not separate top-level slides) — but at <=999px
     (frave-enhance.css) it's unwrapped via "display: contents" instead,
     so its two panes get promoted to be direct, ordinary peek slides of
     the track, no different from the standalone shots after them (two
     photos side by side would each be too small to look at on a phone
     screen; Diptyque's own mobile gallery is a plain one-photo carousel
     throughout, not a split view). slides() below reflects whichever is
     actually true right now (checking computed display, not a hardcoded
     breakpoint, so it can't drift out of sync with the CSS) rather than
     assuming the hero is always exactly one slide.
     Three behaviors, none covered by Focal's own JS since this markup
     isn't a Flickity carousel: (1) prev/next buttons that hide at either
     end, same "nothing to go back to" convention as the carousel
     gallery's own arrows; (2) picking a DIFFERENT fragrance scrolls back
     — to the hero on desktop (showing both photos together again), or
     straight to the scent pane specifically on mobile (there, scrolling
     to the product photo wouldn't itself show that anything changed);
     without this, someone who'd scrolled into the standalone shots and
     then changed scents would have the (now-updated) scent photo sitting
     off-screen with no indication it changed. */
  function wireHalfGalleryNav(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.frave-half-gallery').forEach(function (gallery) {
      var track = gallery.querySelector('.frave-half-gallery__track');
      var prevBtn = gallery.querySelector('.frave-half-gallery__nav--prev');
      var nextBtn = gallery.querySelector('.frave-half-gallery__nav--next');
      if (!track || track.dataset.fraveHalfGalleryWired) return;
      track.dataset.fraveHalfGalleryWired = 'true';

      function slides() {
        var list = [];
        Array.from(track.children).forEach(function (child) {
          if (getComputedStyle(child).display === 'contents') {
            Array.from(child.querySelectorAll('.frave-half-gallery__pane')).forEach(function (pane) {
              list.push(pane);
            });
          } else {
            list.push(child);
          }
        });
        return list;
      }
      function currentIndex() {
        var list = slides(), pos = track.scrollLeft, closest = 0, closestDist = Infinity;
        list.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - pos);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        return closest;
      }
      function goTo(index) {
        var list = slides();
        if (index < 0 || index >= list.length) return;
        track.scrollTo({ left: list[index].offsetLeft, behavior: 'smooth' });
      }
      function resetTarget() {
        var hero = track.querySelector('.frave-half-gallery__slide--hero');
        if (hero && getComputedStyle(hero).display === 'contents') {
          return gallery.querySelector('product-rerender .frave-half-gallery__pane') || hero;
        }
        return hero || slides()[0];
      }

      function update() {
        if (prevBtn) prevBtn.hidden = track.scrollLeft <= 4;
        if (nextBtn) nextBtn.hidden = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(currentIndex() - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(currentIndex() + 1);
        });
      }
      track.addEventListener('scroll', update);
      window.addEventListener('resize', update);
      update();

      var form = document.getElementById(gallery.dataset.observeForm);
      if (form) {
        form.addEventListener('variant:changed', function () {
          var target = resetTarget();
          if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        });
      }
    });
  }
  wireHalfGalleryNav(document);
  document.addEventListener('shopify:section:load', function (event) {
    wireHalfGalleryNav(event.target);
  });

  /* ---- Main gallery: bleed flush to the true left edge ------------------
     Diptyque's gallery starts at the actual browser viewport edge (x: 0) —
     ours sits inset by the page's own container gutter plus a few nested
     layout margins (.container's padding, .product's own margin-inline at
     wider breakpoints). Those nested offsets aren't a single fixed value
     expressible as a plain CSS calc() (container gutter + centering gap +
     product margin-inline all stack, and some only apply above certain
     breakpoints), so this reads the real, current offset via
     getBoundingClientRect() and feeds it into CSS as --frave-media-breakout,
     which frave-enhance.css uses to pull .product__media flush left while
     growing it (and its inner wrapper's max-width guard) by the same
     amount, so only the LEFT edge moves — the right edge (border with
     .product__info) stays put.
     History: an earlier attempt only grew .product__media itself, not
     product-media.liquid's own inline max-width cap on
     .product__media-list-wrapper (there to stop images upscaling past
     their native pixel resolution) — so the wrapper stayed narrower than
     its now-wider parent, sat right-anchored inside it instead of flush,
     and stranded the first slide behind a stray gap (with a cropped-looking
     bottom edge as a side effect of the mismatch). frave-enhance.css now
     removes that cap at the same breakpoint this runs at, accepting minor
     upscaling on any product whose largest source image is smaller than
     the fully-grown column — same trade-off Diptyque's own fixed-slide-
     width approach makes, just from the other direction. */
  function wireGalleryFullBleedLeft(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.product__media').forEach(function (mediaEl) {
      var carousel = mediaEl.querySelector('.product__media-list');

      function update() {
        if (!window.matchMedia('(min-width: 1000px)').matches) {
          mediaEl.style.removeProperty('--frave-media-breakout');
          return;
        }
        // Read with any previous breakout removed first, so re-measuring
        // on resize doesn't compound an already-applied offset.
        mediaEl.style.removeProperty('--frave-media-breakout');
        var offset = mediaEl.getBoundingClientRect().left;
        mediaEl.style.setProperty('--frave-media-breakout', Math.max(offset, 0) + 'px');
        // Defensive: if Flickity already measured the container before this
        // ran (or before an image finished loading and nudged the layout),
        // tell it to re-measure rather than leave cell positions stale.
        if (carousel && carousel.flickityInstance) {
          carousel.flickityInstance.then(function (instance) { instance.resize(); });
        }
      }
      update();
      if (mediaEl.dataset.fraveBleedWired) return;
      mediaEl.dataset.fraveBleedWired = 'true';
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(update, 150);
      });
    });
  }
  wireGalleryFullBleedLeft(document);
  document.addEventListener('shopify:section:load', function (event) {
    wireGalleryFullBleedLeft(event.target);
  });

  /* ---- 04 · Fade page transitions --------------------------------------- */

  if (!REDUCED) {
    // Enter: fade the page in on every load (incl. back/forward cache restore).
    document.documentElement.classList.add('frave-page-enter');
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        document.documentElement.classList.remove('frave-page-leave');
        document.documentElement.classList.add('frave-page-enter');
      }
    });

    // Leave: fade out, then follow the link. Only plain, same-origin,
    // non-modified left-clicks that nothing else (Focal drawers, quick-buy,
    // anchors) has already claimed.
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.getAttribute('href').charAt(0) === '#') return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.hash) return;

      e.preventDefault();
      document.documentElement.classList.remove('frave-page-enter');
      document.documentElement.classList.add('frave-page-leave');
      setTimeout(function () { location.href = a.href; }, 200);
    });
  }
})();
